import React, { FC } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { IntlRfpHeaderProps } from './IntlRfpHeader.types';
import { StyledIntlRfpHeader } from './IntlRfpHeader.styles';

export const IntlRfpHeaderConfig = {
  emptyLabel: 'IntlRfpHeader',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/rfp/eventinfoheader`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IntlRfpHeader: FC<{ model: IntlRfpHeaderProps }> = (props: any) => {
  const { title, description, styleclass } = props.model;

  return (
    <EditableComponent config={IntlRfpHeaderConfig} {...props}>
      <div
        className={`fullbleed m-container-fullbleed ${styleclass}`}
        data-testid="eventinfoheader"
        data-component-name="o-groups-eventinfoheader"
      >
        <StyledIntlRfpHeader className="container py-5">
          <h1 className="t-title-s">{title}</h1>
          <span className="t-font-xs">{description}</span>
        </StyledIntlRfpHeader>
      </div>
    </EditableComponent>
  );
};
